import { ValidationResult } from '../../types'

export const getValidationErrorsByPath = (
  errors: Record<string, ValidationResult[]>,
  prefix: string
): Record<string, ValidationResult[]> => {
  const prefixDot = `${prefix}.`

  return Object.fromEntries(
    Object.entries(errors)
      .filter(([key, value]) => key.startsWith(prefixDot) && value.length > 0)
      .map(([key, value]) => [key.slice(prefixDot.length), value])
  )
}
